import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackMetaAccountConnectionInitiated.meta';

export type MetaAccountTrackingLocation = 'integrations-settings';

export type TrackMetaAccountConnectionInitiatedParams = {
  trackLocation?: MetaAccountTrackingLocation;
};

export const useTrackMetaAccountConnectionInitiated = () => {
  const { track } = useAnalyticsUtilities();

  const trackMetaAccountConnectionInitiated = useCallback(
    (params?: TrackMetaAccountConnectionInitiatedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackMetaAccountConnectionInitiated };
};
